// Sidebar entries owned by the Operations module. The shell places them: see
// src/app/nav.tsx and src/modules/README.md.
import { SidebarType } from '@/types/shared'
import { OPERATIONS_DEPARTMENT_IDS } from './constants'
import { operationsPaths } from './paths'

export const operationsNav = {
    // Temporary client-side gate (admin or Technology / Development). The real
    // gate is server-side: servicemgmt `/internal/ops/*` needs the Keycloak
    // group `/Admin` (EmployeeRequired) and answers 403 otherwise.
    dashboard: {
        title: 'operations:sidebar_dashboard',
        path: operationsPaths.operationsDashboard,
        allowed_department_ids: OPERATIONS_DEPARTMENT_IDS,
    },
    services: {
        title: 'operations:sidebar_services',
        path: operationsPaths.operationsServices,
        allowed_department_ids: OPERATIONS_DEPARTMENT_IDS,
    },
    resources: {
        title: 'operations:sidebar_resources',
        path: operationsPaths.operationsResources,
        allowed_department_ids: OPERATIONS_DEPARTMENT_IDS,
    },
    orgs: {
        title: 'operations:sidebar_orgs',
        path: operationsPaths.operationsOrgs,
        allowed_department_ids: OPERATIONS_DEPARTMENT_IDS,
    },
    cdn: {
        title: 'operations:sidebar_cdn',
        path: operationsPaths.operationsCdn,
        allowed_department_ids: OPERATIONS_DEPARTMENT_IDS,
    },
} satisfies Record<string, SidebarType>
